import styled from "styled-components";

export const StyledAbout = styled.section`
  background-color: ${({ theme }) => theme.backgroundColor.dark};
  color: ${({ theme }) => theme.color.lightGray};
  padding-bottom: 3rem;

`;

export const AboutContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  margin-top: 2rem;

  @media all and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: column;
    margin-top: 0;
    align-items: center;
  }
`;

export const AboutImageContainer = styled.div`
  width: 42%;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  @media all and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 65%;
    margin-bottom: 1rem;
  }

  @media all and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 85%;
  }

  @media all and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
  }
`;

export const AboutImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 1px;
  display: block;
`;

export const AboutDetailsContainer = styled.div`
  width: 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.5rem;
  padding: 3rem 0;

  @media all and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 100%;
    padding: 0;
  }
`;

export const Resume = styled.div`
  display: inline-block;
  margin-top: 1rem;
  position: relative;
  transition: 0.3s ease;

  &::after {
    content: "";
    display: block;
    position: absolute;
    right: 0;
    left: 0;
    bottom: -0.5rem;
    height: 1px;
    border-radius: 5px;
    background: ${({ theme }) => theme.backgroundColor.orange};
    width: 100%;
    transition: transform 0.3s ease;
    transform: scaleX(0);
    transform-origin: bottom right;
  }

  &:hover::after {
    transform: scaleX(1);
    transform-origin: bottom left;
  }

  @media all and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-top: 1rem;
  }
`;

export const ResumeLink = styled.a`
  color: #fff;
  letter-spacing: 2px;
  font-weight: 600;
  cursor: pointer;

  &::before {
    content: ${(props) => `url(${props.icon})`};
    position: absolute;
    right: -2rem;
    opacity: 0;
    filter: alpha(opacity=0);
    -webkit-transform: translateX(-20px);
    transform: translateX(-20px);
    transition: all 0.3s;
  }

  &:hover::before {
    opacity: 1;
    filter: alpha(opacity=100);
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }

  &:hover::after {
    color: ${({ theme }) => theme.color.light};
  }

  @media all and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: 1rem;
  }
`;